import { useEffect } from 'react';
import { pushMessaging } from '@mssgme/lib';
import { useActions } from '@mssgme/hooks';

export default function usePushMessaging(shouldSubscribe = false) {
    const { api } = useActions();

    useEffect(() => {
        async function subscribe() {
            try {
                const isGranted = await pushMessaging.askPermission();
                let subscription = await pushMessaging.getSubscription();

                if (subscription && !isGranted) {
                    await pushMessaging.unsubscribe();
                    return;
                }
                if (!isGranted) return;
                if (!subscription) {
                    subscription = await pushMessaging.subscribe();
                }
                if (subscription) {
                    await api.users.saveMySubscription({ payload: subscription });
                }
            } catch (err) {
                pushMessaging.handleError(err);
            }
        }

        if (shouldSubscribe) {
            subscribe();
        }
    }, [shouldSubscribe]);
}
